export class WareHouseInfo {
    wareHouseID: string;
    wareHouseName: string;
    wareHouseMasterID: string;
    wareHouseIDName: string;
   
    constructor() {
        this.wareHouseID = '';
        this.wareHouseName = '';
        this.wareHouseMasterID = '';
        this.wareHouseIDName = ''
    }
}